import { render, staticRenderFns } from "./BaseScreenTabListView.vue?vue&type=template&id=82e8e046&scoped=true&"
import script from "./BaseScreenTabListView.vue?vue&type=script&lang=js&"
export * from "./BaseScreenTabListView.vue?vue&type=script&lang=js&"
import style0 from "./BaseScreenTabListView.vue?vue&type=style&index=0&id=82e8e046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e8e046",
  null
  
)

export default component.exports